export default __webpack_public_path__ + "static/media/dashboard_banner.cdbc1833.png";